var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOnlinePlatforms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 40.966,
    height: 25.327,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_online_platforms",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(333.35 227.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21957",
    "data-name": "Path 21957",
    d: "M4.1.245V20.013L.54,24.074H38.2l-3.559-4.061V.245Z",
    transform: "translate(1.11 0.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21958",
    "data-name": "Path 21958",
    d: "M5.962,20.8V1.5H35.007V20.8l2.657,3.03H3.305ZM4.461,0V20.236L0,25.33H40.966l-4.461-5.094V0Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 30.543,
    height: 1.498,
    transform: "translate(5.213 18.062)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 18.181,
    height: 1.498,
    transform: "translate(11.393 21.383)",
    fill: "#ff9535"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 23.171,
    height: 12.096,
    transform: "translate(8.546 3.841)",
    fill: "#946290"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226-2",
    "data-name": "Group 226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21959",
    "data-name": "Path 21959",
    d: "M2.411,4.179a3.307,3.307,0,1,1,3.3,3.305,3.3,3.3,0,0,1-3.3-3.305",
    transform: "translate(4.961 1.798)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlinePlatforms);
export default __webpack_public_path__ + "static/media/ic_online_platforms.097acd059c7c5a9afaa1f2deeff2e1e0.svg";
export { ForwardRef as ReactComponent };